// extracted by mini-css-extract-plugin
var _1 = "Distance__Distance___eYSZn";
var _2 = "Distance__light___ZtLNN";
var _3 = "Distance__no-line___ks6kw";
var _4 = "Distance__right___YW95A";
var _5 = "Distance__thick___Bnp1x";
var _6 = "Distance__wiggle___MLmvr";
export { _1 as "Distance", _2 as "light", _3 as "no-line", _4 as "right", _5 as "thick", _6 as "wiggle" }
